module.exports = __webpack_public_path__ + "img/DieLagune.98244363.svg";